import React from "react";
import { Thermostat, AcUnit, LocalFireDepartment } from "@mui/icons-material";

/**
 * Get icon for thermostat widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getThermostatIcon = (widget = null) => {
  // Get thermostat mode
  const mode = widget?.items?.$w1?.value || "off";

  const iconProps = {
    style: { fontSize: "1.5rem", paddingBottom: "2px" },
  };

  // Use different icon based on mode
  if (mode === "heat" || mode === "emergency heat") {
    return <LocalFireDepartment {...iconProps} />;
  } else if (mode === "cool") {
    return <AcUnit {...iconProps} />;
  }

  return <Thermostat {...iconProps} />;
};

/**
 * Get subtitle text for thermostat widgets
 * @param {object} widget - Full widget object
 * @returns {string} Subtitle text
 */
export const getThermostatSubtitle = (widget = null) => {
  if (!widget) return "";

  const mode = widget?.items?.$w1?.value || "off";
  const targetTemp = widget?.items?.$w2?.value;
  const currentTemp = widget?.items?.$w3?.value;
  const unit = widget?.items?.$w2?.unit || "°C";

  // Capitalize first letter of mode
  const modeText = mode.charAt(0).toUpperCase() + mode.slice(1);

  if (targetTemp !== undefined && targetTemp !== null) {
    if (currentTemp !== undefined && currentTemp !== null) {
      return `${modeText}, ${currentTemp}${unit} → ${targetTemp}${unit}`;
    }
    return `${modeText}, ${targetTemp}${unit}`;
  }

  return modeText;
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getThermostatPatterns = () => {
  return ["basic.device.thermostat"];
};
